<template>
    <div class="modal-content">
        <button class="btn-close-news-modal" @click="closeNewsModal()"><svgIcon name="close" class="icon-close"/></button>
        <transition name="fade" v-if="this.config[0].loading && projectHost != 'nurly-dala2'">
            <div class="news-loading-element">
                <img src="@/assets/images/loader.gif" alt="">
            </div>
        </transition>
        <div class="news-modal-content" :class="{notVisible: this.config[0].notVisible}">
            <div class="col-left">
                <div class="news-modal-top-titles">
                    <h3>{{salesCard.site_news_modal_title}}</h3>
                    <!-- <div class="desc">
                        <p>{{flatsWords.flats_cards_info.site_news_modal_desc}}</p>
                    </div> -->
                </div>
                <!-- select month -->
                <div class="news-modal-info-selection-item" v-if="this.config[0].visible">
                    <select id="select-month" v-if="!isMobileChecker">
                        <option :value="index" v-for="(item, index) in newsData" :key="index">
                            {{item.news_modal_month}}
                        </option>
                    </select>
                    <div class="select-in" v-if="isMobileChecker">
                        <select v-model="valueOption" id="select-news-modal-mobile">
                            <option v-for="(item, index) in newsData" :key="index" :value="index">
                                <span>{{item.news_modal_month}}</span>
                            </option>
                        </select>
                        <svgIcon name="calendar" class="icon-calendar"/>
                        <div class="icon-elem">
                            <svgIcon name="down-arrow" class="icon-down-arrow"/>
                        </div>
                    </div>
                    <svgIcon name="calendar" class="icon-calendar" v-if="!isMobileChecker"/>
                    <div class="icon-elem" v-if="!isMobileChecker">
                        <svgIcon name="down-arrow" class="icon-down-arrow"/>
                    </div>
                    {{this.initSelectrick()}}
                </div>
                <!-- end select month -->
                <div class="news-modal-info-list" v-if="this.config[0].visible">
                    <ul>
                        <li v-for="(item, index) in newsData[valueOption].news_modal_list_info" :key="index">
                            <p>{{item.desc}}</p>
                        </li>
                    </ul>
                </div>
                <div class="news-modal-info-desc" v-if="this.config[0].visible">
                    <p>{{newsData[valueOption].news_modal_list_desc}}</p>
                </div>
            </div>
            <div class="col-right">
                <div class="news-info-modal-carousel" v-if="this.config[0].visible">
                    <swiper :options="swiperOption">
                        <swiper-slide 
                            v-for="(slide, index) in newsData[valueOption].news_modal_gallery" :key="index"
                            :style="'background-image:url(' + slide.url + ')'"
                        >
                        </swiper-slide>
                    </swiper>
                    <div class="swiper-controls swiper-controls-sales-land-news">
                        <div class="news-prev-slide slider-btn slider-btn-prev"><svgIcon name="left-arrow" class="icon-left-arrow"/></div>
                        <div class="news-next-slide slider-btn slider-btn-next"><svgIcon name="right-arrow" class="icon-right-arrow"/></div>
                    </div>
                    <!-- <div class="swiper-controls news-controls">
                        <div class="news-btn-prev slider-btn slider-btn-prev"><svg-icon icon-class="left-arrow" className="icon-left-arrow"/></div>
                        <div class="news-btn-next slider-btn slider-btn-next"><svg-icon icon-class="right-arrow" className="icon-right-arrow"/></div>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'NewsModal',
        props: ['config'],
        components: {
            svgIcon,
        },
        data () {
            return {
                valueOption: 0,
                projectHost: window.host,
                swiperOption: {
                    speed: 600,
                    observer: true,
                    observeParents: true,
                    spaceBetween: 20,
                    effect: 'slide',
                    navigation: {
                        nextEl: '.news-next-slide',
                        prevEl: '.news-prev-slide',
                    }
                },
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            newsData: 'loadNewsData',
            isMobileChecker: 'loadIsMobileChecker',
        }),
        methods: {
            closeNewsModal() {
                this.$modal.hide('news-modal');
            },
            initSelectrick() {
                var _self = this;
                setTimeout(() => {
                    var select = $('#select-month'),
                    selectParent = $('.news-modal-info-selection-item');
                    select.selectric();
                    select.selectric({
                        onChange: function() {
                            _self.valueOption = $(this).val();
                        },
                        onOpen: function() {
                            selectParent.addClass('open');
                        },
                        onClose: function() {
                            selectParent.removeClass('open');  
                        }
                    });
                }, 50);
            }
        },
    } 
</script>

<style lang="scss" scoped>
    @import '@/styles/components/news/news-modal.scss';
    @import '@/styles/components/news/news-respond/news-modal-respond.scss';
</style>